import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
/**
 * Privacy utilities for file-uploader
 * Replaces pivot-shared/util/privacy
 */

import logger from './logger';
var log = logger.createLogger('privacy');

// TODO: import from graphistry-js
export var PrivacyMode = Object.freeze({
  Private: 'private',
  Public: 'public',
  Organization: 'organization'
});

/**
 * Gets the privacy mode using the capabilities from the entitlements.
 *
 * @param {Object}  entitlements entitlements object.
 *
 * @return {PrivacyMode} Returns the PrivacyMode value.
 */
export function getPrivacyMode(_ref) {
  var username = _ref.username,
    org = _ref.org,
    entitlements = _ref.entitlements;
  log.debug({
    entitlements: entitlements,
    username: username,
    org: org
  }, 'getPrivacyMode using entitlements');
  var cloudKey = 'GRAPHISTRY_CLOUD';
  if (cloudKey in entitlements && entitlements[cloudKey] === true) {
    for (var _i = 0, _Object$entries = Object.entries(entitlements); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        plan = _Object$entries$_i[0],
        entitlement = _Object$entries$_i[1];
      if (!entitlement.is_active) {
        continue;
      }
      if (['enterprise', 'team'].includes(plan)) {
        return PrivacyMode.Organization;
      }
      if (plan === 'individual') {
        return PrivacyMode.Private;
      }
    }
    return PrivacyMode.Public;
  } else {
    if (username !== org) {
      return PrivacyMode.Organization;
    } else {
      return PrivacyMode.Private;
    }
  }
}